import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Link from 'next/link';
import Changeyear from '../yearchange';

export default class index extends Component {
    nothingToDo = () => { }
    render() {
        return (
            <div>
                <Container fluid={true} className="mobile-footer-m">
                    <div className="footer-sec mb-sm-2">
                        <Container>
                            <div className="pl-sm-5 pr-sm-4 ipad-footer">
                                <div className="pt-4 pb-3 pl-sm-5 pr-sm-5">
                                    <Row>
                                        <Col className="text-center ipad-box-left">
                                            <Link href="/" as="/">
                                                <a>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Logo.svg`}
                                                        alt="GadgetZippy.com iPhone Repair Shop Near Me"
                                                        className="m-auto img-fooetr-mobile desktop"
                                                        onClick={this.props.isHome == true ? this.props.onLoad : this.nothingToDo} />
                                                </a>
                                            </Link>
                                            <Link href="/" as="/">
                                                <a>
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/footer-logo-img.png`}
                                                        alt="GadgetZippy.com iPhone Repair Shop Near Me"
                                                        className="m-auto img-fooetr-mobile1 mobile"
                                                        onClick={this.props.isHome == true ? this.props.onLoad : this.nothingToDo} />
                                                </a>
                                            </Link>
                                            <div className="pt-4 desktop">
                                                <a href="mailto:Repair@Gadgetzippy.com" className="" target="_blank">
                                                    <div className="custome-row">
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Email.svg`} alt="Email" className="" />
                                                        <div className="footer-item pt-2 pl-2">Repair@Gadgetzippy.com</div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="pt-4 desktop">
                                                <a href="tel: +91 99126 99999" className="">
                                                    <div className="custome-row">
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Phone-sm.svg`} alt="Call" className="" />
                                                        <div className="footer-item pt-2 pl-2">+91 99126 99999</div>
                                                    </div>
                                                </a>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mobile-footer-box">
                                                <Link href="/" as="/">
                                                    <a>
                                                        <div className="footer-item pt-3" onClick={this.props.isHome == true ? this.props.onLoad : this.nothingToDo}>Home</div>
                                                    </a>
                                                </Link>
                                                <Link href="/aboutUs" as="/aboutUs">
                                                    <a>
                                                        <div className="footer-item pt-3">Who we are</div>
                                                    </a>
                                                </Link>
                                                {/* <div className="footer-item pt-3">Why us?</div> */}
                                                {/* <div className="footer-item pt-3">Happy Customers</div> */}
                                                <Link href="/offers">
                                                    <a>
                                                        <div className="footer-item pt-3">Offers</div>
                                                    </a>
                                                </Link>
                                                <a href="https://blog.gadgetzippy.com" target="_blank"><div className="footer-item pt-3">Blog</div></a>
                                                {/* <div className="footer-item pt-3">Get in Touch</div> */}
                                                <Link href="/faq">
                                                    <a>
                                                        <div className="footer-item pt-3">FAQ</div>
                                                    </a>
                                                </Link>
                                                <Link href="/privacy">
                                                    <a>
                                                        <div className="footer-item pt-3">Privacy</div>
                                                    </a>
                                                </Link>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mobile mt-4 mb-3 ml-2 mr-2">
                                                <Row>
                                                    <Col>
                                                        <a href="mailto:Repair@Gadgetzippy.com" className="">
                                                            <div>
                                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Mail-Icon-sm.png`} alt="Call" className="" />
                                                                <div className="footer-item footer-item-l">Repair@Gadgetzippy.com </div>
                                                            </div>
                                                        </a>
                                                    </Col>
                                                    <Col>
                                                        <a href="tel: +91 99126 99999" className="">
                                                            <div>
                                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Phone-Icon-sm.png`} alt="Call" className="" />
                                                                <div className="footer-item footer-item-l"> +91 99126 99999 </div>
                                                            </div>
                                                        </a>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="footer-item pt-3 cursor-non-pointer letsgetStart">Lets get social</div>
                                            <div className="mt-3 desktop letsgetStart">
                                                <a href="https://www.facebook.com/GadgetZippy/" target="_blank">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Facebook.svg`} alt="fb gadgetzippy" className="" />
                                                </a>
                                                
                                                <a href="https://api.whatsapp.com/send?phone=919912699999&text=Hi" target="_blank">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/WhatsApp.svg`} alt="whatsapp" className="ml-3" />
                                                </a>
                                            </div>
                                            <div className="mt-3 desktop letsgetStart">
                                                <a href="https://www.instagram.com/gadgetzippy/" target="_blank">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Instagram.svg`} alt="insta gadgetzippy" className="" />
                                                </a>
                                                <a href="https://twitter.com/gadgetzippy" target="_blank">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Twitter.svg`} alt="twt gadgetzippy" className="ml-3" />
                                                </a>
                                            </div>
                                            <div className="mt-4 mobile">
                                                <a href="https://api.whatsapp.com/send?phone=919912699999&text=Hi">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/m-whatsapp.png`} alt="whatsapp" className="mar-box-ccv" />
                                                </a>
                                                <a href="https://www.facebook.com/GadgetZippy/">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/m-Facebook.png`} alt="fb gadgetzippy" className="mar-box-ccv" />
                                                </a>
                                                <a href="https://www.instagram.com/gadgetzippy/">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/m-Instagram.png`} alt="insta gadgetzippy" className="mar-box-ccv" />
                                                </a>
                                                <a href="https://twitter.com/gadgetzippy">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/m-Twitter.png`} alt="twt gadgetzippy" className="mar-box-ccv" />
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="copy-right pt-2">
                                      <Changeyear/>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </Container>
            </div>
        )
    }
}
